import React from 'react';

const ModalFooter = (props) => {
  return (
    <div
      className="sticky bottom-0 flex w-full flex-row flex-wrap items-center justify-end gap-2 border-t border-neutral-200 bg-basic-white px-4 py-3"
      {...props}
    />
  );
};

export default ModalFooter;
